module.exports = __webpack_public_path__ + "img/gigwicat2.93126ecc.jpg";